import React from 'react';
import PropTypes from 'prop-types';

import {core} from 'react-page-maker';
import state from '../state';

class Preview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentState: this.props.state && [{id:'root',fields: this._setInitialElements(this.props.state)}] || state.getState()
        };

        this.registeredPaletteElements = core.getRegisteredPaletteElements();

        // state.addEventListener('change',this._onStateChange);
    }

    componentWillReceiveProps(nextProps){
        if( nextProps.state )
            this.setState({currentState: [{id:'root',fields: this._setInitialElements(nextProps.state)}]});
    }

    // keep track of state tree changes
    _onStateChange = (newState) => {
        this.setState({
            currentState: newState
        });
    }

    _setInitialElements = (initialElements) => {
        // current component state(droppedElements) doesn't hold any elements
        // but initialElements has some element to be set
        const gotInitialItems = Array.isArray(initialElements) && initialElements.length

        // for first time add initialElements to droppedElements

        if (gotInitialItems) {
            const { id: dropzoneID, payload } = this.props;
            const updatedInitialItems = initialElements.map(e => ({
                ...e,
                key: e.id,
                dropzoneID,
                parentID:'root'
            }));

            return updatedInitialItems;
        }else
            return []
    }

    /**
     * recuresive function to iterate through all node of state tree and
     * render approprate component and pass necessary props
     * @param element {Object} - infomation of state tree node
     * @returns {JSX} - Preview/JSX representation of current state tree
     */
    _renderElementInPreviewMode = (element) => {
        const children = {};
        const elementData = this.registeredPaletteElements
        .find(e => e.type === element.type);

        // element has sub fields, render those fields first
        // and then come back to current field
        if (Array.isArray(element.fields)) {
            element.fields.forEach((field) => {
                children[field.dropzoneID] = children[field.dropzoneID] || [];
                children[field.dropzoneID] = children[field.dropzoneID]
                .concat(this._renderElementInPreviewMode(field));
            });
        }

        // render corresponding component and pass necessary props
        // showPreview is mandatory
        return (
            <elementData.component
                id={element.id}
                key={element.id}
                childNode={children}
                {...{ ...element, showPreview: true, showBasicContent: false }}
            />
        );
    }

    render() {
        const root = this.state.currentState[0];

        // if you want more flexiblity
        if (typeof this.props.children === 'function') {
            return this.props.children({
                children: root.fields.map(this._renderElementInPreviewMode)
            });
        }

        // standard render - only <Preview /> and done
        return (
            <div className="preview-container">
                {
                    root.fields.map(this._renderElementInPreviewMode)
                }
            </div>
        );
    }
}

Preview.propTypes = {
    children: PropTypes.func
};

export default Preview;
